import type { InvestigatorRecord } from '@/data/researchCatalog';

/**
 * Nombre de unidad listo para mostrar: la abreviatura cuando existe.
 *
 * SIEMPRE la abreviatura, no sólo cuando el nombre completo pasa cierto largo.
 * Hubo un umbral de 34 caracteres y falló justo donde importaba: "Centro de
 * Investigaciones Costeras" mide 34 clavados, así que no lo cruzaba y se mostraba
 * entero en vez de CIC. Y mirando las 28 unidades cargadas, la abreviatura es
 * mejor en todos los casos —"Kinesiología" sobre "Departamento de Kinesiología"—
 * porque el prefijo lo comparten casi todas y no distingue nada.
 *
 * Vive acá, y no en la vista, porque la portada y el directorio tienen que cortar
 * igual: si divergen, la misma persona aparece con dos nombres de unidad
 * distintos en dos pantallas del mismo sitio.
 */
export const nombreUnidad = (inv: Pick<InvestigatorRecord, 'unit' | 'unitShort'>) =>
	inv.unitShort?.trim() || inv.unit;

/**
 * Nombre de macrounidad listo para mostrar, con el mismo criterio.
 *
 * Las dos abreviaturas salen de `nombre_abreviado` en la base — la tienen tanto
 * `unidad` como `macrounidad`. Son las buenas: CRIDESAT, IDICTEC, IICSE, CIC.
 */
export const nombreMacrounidad = (inv: Pick<InvestigatorRecord, 'macroUnit' | 'macroUnitShort'>) =>
	inv.macroUnitShort?.trim() || inv.macroUnit || '';
